module.exports = __webpack_public_path__ + "media/images/posts/winter_wedding-a721ec8d8ea489b8db07af7f8450dd04.jpg";